import React from 'react';
import type { CSSProperties } from 'react';
import type { ImageItemProps } from './types';
import { getImageUrl, getAspectRatioClass } from './utils';
import {
  getCroppedImageRenderProps,
  getCroppedImageStyles,
  hasCropApplied,
} from '../ComponentEditModal/shared/cropUtils';

export const ImageItem: React.FC<ImageItemProps> = ({
  item,
  index,
  isMasonry = false,
  lightboxEnabled,
  lazyLoading,
  captionPosition,
  aspectRatio,
  captionColor,
  imageRefs,
  onImageClick,
}) => {
  const imageUrl = getImageUrl(item);
  const aspectClass = isMasonry ? '' : getAspectRatioClass(aspectRatio);
  const crop = (item as any).crop;
  const frameSlot = Boolean(aspectClass);

  let hasCrop: boolean;
  let imageStyle: CSSProperties | undefined;
  let containerStyle: CSSProperties | undefined;

  if (frameSlot) {
    hasCrop = hasCropApplied(crop);
    imageStyle = hasCrop ? getCroppedImageStyles(crop) : undefined;
  } else {
    const aspectProps = getCroppedImageRenderProps(crop);
    hasCrop = aspectProps.hasCrop;
    imageStyle = hasCrop ? aspectProps.imageStyle : undefined;
    containerStyle =
      hasCrop && aspectProps.aspectRatio ? { aspectRatio: aspectProps.aspectRatio } : undefined;
  }

  return (
    <div
      className={`relative group overflow-hidden w-full ${lightboxEnabled ? 'cursor-pointer' : ''}`}
      onClick={() => onImageClick(index)}
    >
      <div className={`relative overflow-hidden w-full ${aspectClass}`} style={containerStyle}>
        <img
          ref={
            lazyLoading
              ? el => {
                  imageRefs.current[index] = el;
                }
              : undefined
          }
          src={imageUrl}
          alt={item.alt || `Gallery image ${index + 1}`}
          className={`transition-transform duration-300 ${
            lightboxEnabled ? 'group-hover:scale-105' : ''
          } ${!hasCrop ? 'w-full h-full object-cover' : ''}`}
          style={hasCrop ? imageStyle : undefined}
          loading={lazyLoading ? 'lazy' : undefined}
        />
      </div>
      {captionPosition === 'overlay' && item.caption && (
        <div className="absolute bottom-0 left-0 right-0 bg-black/70 p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          {/* Inline color on <p>: global `p { text-modern-body }` would override inherit from this div in the page editor */}
          <p className="text-sm" style={{ color: captionColor }}>
            {item.caption}
          </p>
        </div>
      )}
      {captionPosition === 'below' && item.caption && (
        <p className="mt-2 text-sm" style={{ color: captionColor }}>
          {item.caption}
        </p>
      )}
    </div>
  );
};
